<template>
  <div class="signIn">
    <welcome-image/>
    <section class="signIn__right">
      <form class="signIn__form">
        <div class="signIn__line">
          <label class="signIn__textLabel">Почта</label>
          <form-input autocomplete="false" v-model="userLogin" type="text"/>
        </div>
        <div class="signIn__line">
          <label class="signIn__textLabel">Пароль</label>
          <form-input autocomplete="false" v-model="password" :type="showPassword ? 'text':'password' "/>
          <div class="signIn__options">
            <CheckBox
                style="color: var(--cd-text-muted)"
                text="Показать пароль"
                v-model="showPassword"
            ></CheckBox>
            <router-link class="signIn__link" :to="{name: 'ResetPasswordView'}">Забыли пароль</router-link>
          </div>
        </div>
        <div class="signIn__line">
          <div class="signIn__Buttons">
            <ActionButton
                :disabled="!userLogin || !password"
                style="width: 110px"
                icon-type="arrow"
                @button-click="loginHandler"
            >
              <template #caption>Войти</template>
            </ActionButton>
          </div>
        </div>
        <div class="signIn__line">
          <span class="signIn__noAccount">
             Нет аккаунта? &nbsp;
              <router-link class="signIn__link" :to="{name: 'SignUpStep1View'}">Зарегистрируйтесь</router-link>
          </span>
        </div>
      </form>
    </section>

  </div>
</template>

<script>
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {ref} from "vue";
import FormInput from "@/components/ui/FormInput.vue";
import WelcomeImage from "@/components/shared/WelcomeImage.vue";
import {useAuthStore} from "@/store/auth";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";

export default {
  name: "SignInView",
  components: {WelcomeImage, FormInput, ActionButton, CheckBox},
  setup() {
    const showPassword = ref(false)
    const password = ref(null)
    const userLogin = ref(null)
    const authStore = useAuthStore();
    const router = useRouter();
    const toast = useToast();

    async function loginHandler() {
      if (authStore.loading) {
        return;
      }
      console.log('loginHandler');
      await authStore.doLogin(userLogin.value, password.value);
      if (authStore.error) {
        toast.error(authStore.error);
        return;
      }
      await router.push({name: 'HomePage'})
    }

    return {showPassword, password, userLogin, loginHandler}
  }
}
</script>


<style scoped lang="scss">
.signIn {
  display: flex;
  padding: 60px 0;
  gap: 22px;
  align-items: stretch;
  @include respond-to('md') { flex-direction: column; padding: 32px 0; }

  &__right {
    flex: 1 1 0;
    min-width: 0;
    border-radius: 20px;
    background: var(--cd-card-bg);
    padding: 34px;

    @include respond-to('sm') { padding: 20px; }
  }

  &__textLabel {
    padding: 10px 10px;
    display: block;
  }

  &__textLabel--muted {
    display: block;
    color: var(--cd-text-muted);
    margin: 20px 0;
  }

  &__form {
    text-align: left;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--cd-default-font);
  }

  &__options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: $space-xs;
  }

  &__link {
    color: var(--cd-link-color);
    text-decoration: none;
  }

  &__line {
    padding-bottom: 24px;
  }

  &__noAccount {
    color: var(--cd-text);
  }
}
</style>
